export const variaveisAquecimento = [
    { nome: '0,0', valor: 0.0 },
    { nome: '1,0', valor: 1.0 },
    { nome: '2,0', valor: 2.0 },
    { nome: '3,0', valor: 3.0 },
    { nome: '4,0', valor: 4.0 },
    { nome: 'Plenum', valor: 'PLENUM' },
];
